import { Action } from '@ngrx/store';

export const ENABLE_CONSENT =  '[Consent] Enable';
export const DISABLE_CONSENT = '[Consent] Disable';

/**
 * Action to initiate process to enable consent .
 */
export class EnableConsentAction implements Action {
    readonly type = ENABLE_CONSENT;
}

/**
 * Action to initiate request to disable consent.
 */
export class DisableConsentAction implements Action {
    readonly type = DISABLE_CONSENT;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = EnableConsentAction
    | DisableConsentAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/actions/update-consent.actions.ts